export default __webpack_public_path__ + "static/bg1920-33c5ea4620320c8125382b82ddf96a77.png";